if (!customElements.get('before-after')) {
  class BeforeAfter extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.before-after-container');
      this.slider = this.querySelector('.before-after-slider');
      this.beforeContainer = this.querySelector('.image-banner--before');
      this.afterContainer = this.querySelector('.image-banner--after');
      this.beforeImageWrapper = this.beforeContainer.querySelectorAll(
        '.image-banner__image-wrapper',
      );
      this.beforeTextWrapper = this.beforeContainer.querySelector(
        '.image-banner__text-wrapper',
      );
      this.afterImageWrapper = this.afterContainer.querySelectorAll(
        '.image-banner__image-wrapper',
      );
      this.afterTextWrapper = this.afterContainer.querySelector(
        '.image-banner__text-wrapper',
      );
      this.isDragging = false;

      // Check if mobile
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      this.currentPosition = isMobile ? 15 : 50; // 15% on mobile, 50% on desktop

      this.initializeSlider();

      // Trigger initial position update
      this.updateSliderPosition(
        this.container.getBoundingClientRect().width *
          (isMobile ? 0.15 : 0.501),
      );
    }

    initializeSlider() {
      this.classList.add('is-loaded');

      this.slider.addEventListener('mousedown', (e) => {
        this.isDragging = true;
        e.preventDefault();
      });

      document.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        this.updateSliderPosition(e.clientX);
      });

      document.addEventListener('mouseup', () => {
        this.isDragging = false;
      });

      // Touch events for mobile
      this.slider.addEventListener('touchstart', (e) => {
        this.isDragging = true;
        e.preventDefault();
      });

      document.addEventListener('touchmove', (e) => {
        if (!this.isDragging) return;
        this.updateSliderPosition(e.touches[0].clientX);
      });

      document.addEventListener('touchend', () => {
        this.isDragging = false;
      });
    }

    updateSliderPosition(clientX) {
      const containerRect = this.container.getBoundingClientRect();
      const position = (clientX - containerRect.left) / containerRect.width;
      const percentage = Math.max(0, Math.min(1, position)) * 100;

      this.currentPosition = percentage;
      this.slider.style.left = `${percentage}%`;

      // Update clip paths for both sides
      if (percentage !== 50) {
        // For the "before" side (left)
        this.beforeImageWrapper.forEach((wrapper) => {
          wrapper.style.clipPath = `inset(0 ${
            100 - percentage
          }% 0 0)`;
        });
        this.beforeTextWrapper.style.clipPath = `inset(0 ${
          100 - percentage
        }% 0 0)`;

        // For the "after" side (right)
        this.afterImageWrapper.forEach((wrapper) => {
          wrapper.style.clipPath = `inset(0 0 0 ${percentage}%)`;
        });
        this.afterTextWrapper.style.clipPath = `inset(0 0 0 ${percentage}%)`;
      } else {
        // Reset clip paths when in the middle
        this.beforeImageWrapper.forEach((wrapper) => {
          wrapper.style.clipPath = 'none';
        });
        this.beforeTextWrapper.style.clipPath = 'none';
        this.afterImageWrapper.forEach((wrapper) => {
          wrapper.style.clipPath = 'none';
        });
        this.afterTextWrapper.style.clipPath = 'none';
      }
    }
  }

  customElements.define('before-after', BeforeAfter);
}
